import { fetchDocument } from "./private-document";

export function removeDuplicates(arr: any) {
  return arr.filter((item: any, index: any) => arr.indexOf(item) === index);
}

export function saveBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  // Revoking synchronously can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Downloads a (possibly cross-origin) file without leaving the app.
 * Cross-origin <a download> is ignored by browsers, and in an installed PWA
 * window.open / target="_blank" hands the URL to the system browser, so we
 * fetch the file and save it through a same-origin blob URL instead.
 * Falls back to opening the URL if the fetch fails (e.g. CORS not allowed).
 */
export async function downloadFile(url: string, fileName?: string): Promise<void> {
  if (!url) return;
  const name = fileName || decodeURIComponent(url.split('?')[0].split('/').pop() || 'file');
  try {
    const res = await fetchDocument(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    saveBlob(await res.blob(), name);
  } catch {
    window.open(url, '_blank');
  }
}

export async function readBlobError(error: any): Promise<any> {
  if (error?.error instanceof Blob) {
    try {
      return { ...error, error: JSON.parse(await error.error.text()) };
    } catch {
      return error;
    }
  }
  return error;
}
